import {
    AIRSPACE_PAGE,
    ALL_DATA_PAGE,
    APPLICATIONS_PAGE,
    APPLICATION_DETAILS_PAGE,
    ASSETS_PAGE,
    ASSET_DETAILS_PAGE,
    BATTERY_DETAILS_PAGE,
    BOUNDARIES_PAGE,
    BOUNDARY_DETAILS_PAGE,
    CHEMICALS_PAGE,
    CHEMICAL_DETAILS_PAGE,
    CLIENTS_PAGE,
    CLIENT_DETAILS_PAGE,
    CONNECTIONS_PAGE,
    CREATE_MIX_PAGE,
    DATA_PAGE,
    DRONE_DETAILS_PAGE,
    FARMS_PAGE,
    FARM_DETAILS_PAGE,
    FIELDS_PAGE,
    FIELD_DETAILS_PAGE,
    HOME_PAGE,
    LOGIN_PAGE,
    LOGOUT_PAGE,
    MAINTENANCE_PAGE,
    MIX_DETAILS_PAGE,
    ONBOARDING_CURRENT_USER_PAGE,
    ONBOARDING_ORGANIZATION_CREATION_PAGE,
    REPORTS_PAGE,
    SIGNUP_PAGE,
    SUPPORT_PAGE,
    USERS_PAGE,
    USER_DETAILS_PAGE,
    VERIFY_EMAIL_PAGE
} from './constants';

const usePageRoutes = () => ({
    airspacePage: AIRSPACE_PAGE,
    allDataPage: ALL_DATA_PAGE,
    applicationDetailsPage: (id: string) => `${APPLICATION_DETAILS_PAGE}/${id}`,
    applicationsPage: APPLICATIONS_PAGE,
    assetDetailsPage: (id: string) => `${ASSET_DETAILS_PAGE}/${id}`,
    assetsPage: ASSETS_PAGE,
    batteryDetailsPage: (id: string) => `${BATTERY_DETAILS_PAGE}/${id}`,
    boundariesPage: BOUNDARIES_PAGE,
    boundaryDetailsPage: (id: string) => `${BOUNDARY_DETAILS_PAGE}/${id}`,
    chemicalDetailsPage: (id: string) => `${CHEMICAL_DETAILS_PAGE}/${id}`,
    chemicalsPage: CHEMICALS_PAGE,
    clientDetailsPage: (id: string) => `${CLIENT_DETAILS_PAGE}/${id}`,
    clientsPage: CLIENTS_PAGE,
    connectionsPage: CONNECTIONS_PAGE,
    createMixPage: CREATE_MIX_PAGE,
    dataPage: DATA_PAGE,
    droneDetailsPage: (id: string) => `${DRONE_DETAILS_PAGE}/${id}`,
    farmDetailsPage: (id: string) => `${FARM_DETAILS_PAGE}/${id}`,
    farmsPage: FARMS_PAGE,
    fieldDetailsPage: (id: string) => `${FIELD_DETAILS_PAGE}/${id}`,
    fieldsPage: FIELDS_PAGE,
    homePage: HOME_PAGE,
    loginPage: LOGIN_PAGE,
    logoutPage: LOGOUT_PAGE,
    maintenancePage: MAINTENANCE_PAGE,
    mixDetailsPage: (id: string) => `${MIX_DETAILS_PAGE}/${id}`,
    onboardingCurrentUserPage: ONBOARDING_CURRENT_USER_PAGE,
    onboardingOrganizationCreationPage: ONBOARDING_ORGANIZATION_CREATION_PAGE,
    reportsPage: REPORTS_PAGE,
    signupPage: SIGNUP_PAGE,
    supportPage: SUPPORT_PAGE,
    userDetailsPage: (id: string) => `${USER_DETAILS_PAGE}/${id}`,
    usersPage: USERS_PAGE,
    verifyEmailPage: VERIFY_EMAIL_PAGE
});

export default usePageRoutes;
